module.exports = __webpack_public_path__ + "img/inventory.15e1d8ab.svg";